import React from 'react';

const ButtonBot = ({textYes, textNo, textDisable, disabled, handleYes, handleNo, typeYes="button", typeNo="button", disable, style = {}, icon}) => {


  return (
    <div className='button-bot' style={{...style}}>
      {textNo && !disabled && <button type={typeNo} className='button-bot__btn_no' onClick={handleNo}>{textNo}</button>}
      {textYes && !disabled && <button type={typeYes} style={disable ? { backgroundColor: '#7f7f7f' } : {}} className={`button-bot__btn_yes ${icon && '--has-icon'}`} onClick={disable ? null : handleYes}>
        {icon && <img src={icon} alt="icon" /> }
        {textYes}
      </button>}
      {disabled && <button className='button-bot__btn_disable'>{textDisable ? textDisable : textYes}</button>}
    </div>
  );
};

export default ButtonBot;
